(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productListMarketingTilesBound) return;
    window.__productListMarketingTilesBound = true;

    function insertProductListMarketingTiles(sectionRoot) {
      if (!sectionRoot || !sectionRoot.matches("[data-productlist-marketing-tiles]")) return;

      const blocksHost = sectionRoot.querySelector(".product-list__marketing-blocks");
      if (!blocksHost) return;

      const swiper = sectionRoot.querySelector("swiper-container");
      const grid = sectionRoot.querySelector(".columns");
      const target = swiper || grid;
      if (!target) return;

      const slideTag = swiper ? "swiper-slide" : "div";

      blocksHost
        .querySelectorAll("template[data-productlist-marketing-tile]")
        .forEach(function (tpl) {
          const blockId = tpl.getAttribute("data-block-id") || "";
          if (
            blockId &&
            sectionRoot.querySelector('[data-productlist-block-id="' + blockId + '"]')
          ) {
            return;
          }
          const card = tpl.content && tpl.content.firstElementChild;
          if (!card) return;

          const insertAt = parseInt(tpl.getAttribute("data-insert-at") || "1", 10);
          const safeInsertAt =
            Number.isFinite(insertAt) && insertAt > 0 ? insertAt : 1;

          const wrapper = document.createElement(slideTag);
          if (!swiper) wrapper.className = "grid-item";
          if (blockId) wrapper.setAttribute("data-productlist-block-id", blockId);

          const visibility = tpl.getAttribute("data-visibility") || "show-both";
          if (visibility && visibility !== "show-both") {
            wrapper.classList.add(visibility);
          }
          wrapper.appendChild(card.cloneNode(true));

          const ref = target.children[safeInsertAt - 1];
          if (ref) {
            target.insertBefore(wrapper, ref);
          } else {
            target.appendChild(wrapper);
          }
        });

      if (swiper && swiper.swiper) {
        swiper.swiper.update();
      }
    }

    function insertAllProductListMarketingTiles() {
      document
        .querySelectorAll("[data-productlist-marketing-tiles]")
        .forEach(insertProductListMarketingTiles);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", insertAllProductListMarketingTiles);
    } else {
      insertAllProductListMarketingTiles();
    }

    document.addEventListener("swiper-loaded", insertAllProductListMarketingTiles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("product-recommendations");
            if (!recommendations || !recommendations.innerHTML.trim().length) {
              return;
            }

            const dynamic = this.querySelector(".product-recommendations__dynamic");
            const fetchedDynamic = recommendations.querySelector(
              ".product-recommendations__dynamic"
            );
            if (dynamic && fetchedDynamic) {
              dynamic.innerHTML = fetchedDynamic.innerHTML;
            } else {
              this.innerHTML = recommendations.innerHTML;
            }

            this.insertMarketingTiles();

            const event = new Event("recommendations-loaded", { bubbles: true });
            document.body.dispatchEvent(event);

            if (html.querySelector(".grid__item")) {
              this.classList.add("product-recommendations--loaded");
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }

    insertMarketingTiles() {
      const scope =
        this.querySelector(".product-recommendations__dynamic") || this;
      const swiper = scope.querySelector("swiper-container");
      const grid = scope.querySelector(".columns");
      const target = swiper || grid;
      if (!target) return;

      const tiles = this.querySelectorAll("template[data-reco-marketing-tile]");
      tiles.forEach((tpl) => {
        const blockId = tpl.getAttribute("data-block-id") || "";
        if (blockId && scope.querySelector(`[data-reco-block-id="${blockId}"]`)) {
          return;
        }
        const card = tpl.content && tpl.content.firstElementChild;
        if (!card) return;
        const insertAt = parseInt(tpl.getAttribute("data-insert-at") || "1", 10);
        const safeInsertAt =
          Number.isFinite(insertAt) && insertAt > 0 ? insertAt : 1;

        const slideTag = swiper ? "swiper-slide" : "div";
        const wrapper = document.createElement(slideTag);
        if (!swiper) wrapper.className = "grid-item";
        if (blockId) wrapper.setAttribute("data-reco-block-id", blockId);
        const visibility = tpl.getAttribute("data-visibility") || "show-both";
        if (visibility && visibility !== "show-both") {
          wrapper.classList.add(visibility);
        }
        wrapper.appendChild(card.cloneNode(true));

        const ref = target.children[safeInsertAt - 1];
        if (ref) {
          target.insertBefore(wrapper, ref);
        } else {
          target.appendChild(wrapper);
        }
      });
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"]) return;
  try {
    
  (function () {
    if (window.__recoMarketingTilesBound) return;
    window.__recoMarketingTilesBound = true;

    function insertTilesForSection(sectionRoot) {
      if (!sectionRoot) return;
      const blocksHost = sectionRoot.querySelector(
        ".recommended-products__marketing-blocks"
      );
      if (!blocksHost) return;
      const reco = sectionRoot.querySelector("recommended-products");
      if (!reco) return;
      const target = reco.querySelector(".swiper-wrapper") || reco;
      const isSwiper =
        sectionRoot.matches('[data-swiper="true"]') ||
        sectionRoot.querySelector('[data-swiper="true"]') !== null;
      const slideTag = isSwiper ? "swiper-slide" : "div";

      blocksHost
        .querySelectorAll("template[data-reco-marketing-tile]")
        .forEach(function (tpl) {
          const blockId = tpl.getAttribute("data-block-id") || "";
          if (
            blockId &&
            target.querySelector('[data-reco-block-id="' + blockId + '"]')
          ) {
            return;
          }
          const card = tpl.content && tpl.content.firstElementChild;
          if (!card) return;
          const insertAt = parseInt(
            tpl.getAttribute("data-insert-at") || "1",
            10
          );
          const safeInsertAt =
            Number.isFinite(insertAt) && insertAt > 0 ? insertAt : 1;
          const wrapper = document.createElement(slideTag);
          if (!isSwiper) wrapper.className = "grid-item";
          if (blockId) wrapper.setAttribute("data-reco-block-id", blockId);
          const visibility = tpl.getAttribute("data-visibility") || "show-both";
          if (visibility && visibility !== "show-both") {
            wrapper.classList.add(visibility);
          }
          wrapper.appendChild(card.cloneNode(true));

          const ref = target.children[safeInsertAt - 1];
          if (ref) {
            target.insertBefore(wrapper, ref);
          } else {
            target.appendChild(wrapper);
          }
        });
    }

    document.addEventListener("recommendations-loaded", function () {
      document
        .querySelectorAll(".recommended-products__marketing-blocks")
        .forEach(function (host) {
          const section = host.closest(".shopify-section") || host.parentElement;
          insertTilesForSection(section);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
